import React, { Component } from "react";
import "../../../../public/styles/HomeInteriors/homepage/Form.scss";

import Col from 'react-bootstrap/lib/Col'
import FormGroup from 'react-bootstrap/lib/FormGroup'
import Label from 'react-bootstrap/lib/Label'
import FormControl from 'react-bootstrap/lib/FormControl'


import {
  validateEmptyObject,
  validateFullName,
  regexName,
  regexMobileNo,
  regexEmail,
  validatePindcode,
} from "../../../utils/validationManager";
import {
  FIELDREQ_MSG,
  NAME_VALIDATION_MSG,
  INVALID_MOBILE_NUMBER,
  INVALID_EMAIL_ADDRESS,
  INVALID_PINCODE_FORMAT,
} from "../../../constants/app/primitivesConstants";

import {
  imagePrefix,
  espotAPI,
  HIConsultFormAPI,
} from "../../../../public/constants/constants";
import apiManager from "../../../utils/apiManager";

class Form extends Component {
  constructor(props) {
    super();
    super(props);
    this.state = {
      espotName: "GI_Interiors_ConsultForm",
      bkgImg: "",
      name: null,
      email1: null,
      phone1: null,
      location: null,
      locationErrMsg: null,
      requirements: null,
      budget: null,
      budgetErrMsg: null,
      nameErrMsg: null,
      emailErrMsg: null,
      phoneErrMsg: null,
      contactWA: true,
      checkInterestErrMsg: null,
      requirementsErrMsg: null,
      successMsg: null,
      errorMsg: null,
      requirementsOptions: null,
      interestsList: [],
      locationList: [],
      budgetList: [],
      checkedInterests: [],
      submit: false,
      pincodeErrMsg:null,
      pincode:null,
      possessionList: [],
      possessionErrMsg:null,
      possession: null,
      possessionIndex: null,
    };
  }

  fieldChangeHandler = e => {
    this.setState({
      [e.target.name]: e.target.value !== "" ? e.target.value : null,
    });
  };

  getEspotData() {
    apiManager.get(espotAPI + this.state.espotName).then(response => {
      const { data } = response || {};
      this.setState({
        bkgImg: data && data.data.bkgImg,
        interestsList: data && data.data.formInterests,
        locationList: data && data.data.locations,
        budgetList: data && data.data.budget,
        possessionList: data && data.data.possessions,
      }).catch(error => {
        this.setState({
          error,
          // isLoading: false,
        });
      });
    });
  }

  createSelectItems = (currSelected, selectedList) => {
    let items = [];
    const currentIndex = currSelected;
    items = selectedList && selectedList.length > 0 && selectedList.map((item, index) => (
      <option key={item} value={index} selected={currentIndex === index}>
        {item}
      </option>
    ));

    return items;
  };

  checkedContact = e => {
    this.setState({
      contactWA: !this.state.contactWA,
    });
  };

  onDropdownSelectedLocation = e => {
    if (e.target.value !== "null" && this.state.location !== e.target.value) {
      this.setState({
        location: e.target.value,
        index: e.target.value,
        errorMessageDropOption: null,
      });
    }
  };

  onDropdownSelectedBudget = e => {
    if (e.target.value !== "null" && this.state.budget !== e.target.value) {
      this.setState({
        budget: e.target.value,
        index: e.target.value,
        errorMessageDropOption: null,
      });
    }
  };

  onDropdownSelectedPossession = e => {
    if (e.target.value !== "null" && this.state.possession !== e.target.value) {
      this.setState({
        possession: e.target.value,
        possessionIndex: e.target.value,
        errorMessageDropOption: null,
      });
    }
  };

  checkInterest(val) {
    let temp = this.state.checkedInterests;

    if (temp.includes(val)) {
      temp = temp.filter((value, index, arr) => value != val);
    } else {
      temp.push(val);
    }
    this.setState({
      checkedInterests: temp,
    });
  }

  formValidationHandler = () => {
    this.setState({
      nameErrMsg: null,
      emailErrMsg: null,
      phoneErrMsg: null,
      locationErrMsg: null,
      budgetErrMsg: null,
      requirementsErrMsg: null,
      successMsg: null,
      checkInterestErrMsg: null,
      errorMsg: null,
      pincodeErrMsg: null,
      possessionErrMsg: null,
    });
    let isValid = true;
    const {
      name,
      email1,
      phone1,
      location,
      checkedInterests,
      requirements,
      pincode,
      possession,
    } = this.state;
    if (!validateEmptyObject(name)) {
      this.setState({ nameErrMsg: FIELDREQ_MSG });
      isValid = false;
    } else if (!validateFullName(name) || !regexName.test(name)) {
      this.setState({ nameErrMsg: NAME_VALIDATION_MSG });
      isValid = false;
    }
    if (!validateEmptyObject(email1)) {
      this.setState({ emailErrMsg: FIELDREQ_MSG });
      isValid = false;
    } else if (!regexEmail.test(email1)) {
      this.setState({ emailErrMsg: INVALID_EMAIL_ADDRESS });
      isValid = false;
    }
    if (!validateEmptyObject(pincode)) {
      this.setState({ pincodeErrMsg: FIELDREQ_MSG });
      isValid = false;
    } else if (!validatePindcode(pincode)) {
      this.setState({ pincodeErrMsg: INVALID_PINCODE_FORMAT });
      isValid = false;
    }

    
    if (!validateEmptyObject(phone1)) {
      this.setState({ phoneErrMsg: FIELDREQ_MSG });
      isValid = false;
    } else if (!regexMobileNo.test(phone1)) {
      this.setState({ phoneErrMsg: INVALID_MOBILE_NUMBER });
      isValid = false;
    }
    if (location == "" || location == null || location == "Select an option") {
      isValid = false;
      this.setState({ locationErrMsg: FIELDREQ_MSG });
    }
    if (checkedInterests == "" || checkedInterests == null) {
      isValid = false;
      this.setState({
        checkInterestErrMsg:
          `${FIELDREQ_MSG  }. Please select atleast one of the options`,
      });
    }
    if (possession == "" || possession == null ||  possession=='Select an option') {
      isValid = false;
      this.setState({
        possessionErrMsg:
          `${FIELDREQ_MSG  }. Please select Possession status`,
      });
    }
    

    return isValid;
  };

  submitForm = e => {
    e.preventDefault();
    if (!this.formValidationHandler()) {
      return;
    }
    this.setState({
      submit: true,
    });
    setTimeout(() => {
      this.setState({
        submit: false,
      });
    }, 4000);
    const urlSearchParams = new URLSearchParams(
      window.location.search.substring(1)
    );
    const data = {
      location: this.state.locationList[this.state.location] || "",
      name: this.state.name,
      phone1: this.state.phone1,
      contact: this.state.contactWA == false ? "No" : "Yes",
      // contact: "No",
      email1: this.state.email1,
      budget: this.state.budgetList[this.state.budget] || "",
      interests: this.state.checkedInterests.join("|"),
      formName: "Consultation",
      pageName: "HI_Homepage",
      utmPlacement: urlSearchParams.get("utm_placement"),
      utmMedia: urlSearchParams.get("utm_medium"),
      utmKeyword: urlSearchParams.get("utm_keyword"),
      utmAddgroup: urlSearchParams.get("utm_adgroup"),
      utmCampaign: urlSearchParams.get("utm_campaign"),
      utmSource: urlSearchParams.get("utm_source") || "Website",
      pincode: this.state.pincode,
      possession: this.state.possessionList[this.state.possession] || "",
      // possession: this.state.possession,
    };
    apiManager
      .post(HIConsultFormAPI, data)
      .then(response => {
        const resData = response.data;
        // alert(JSON.stringify(resData, null, 2));
        setTimeout(() => {
          this.setState({
            submit: false,
          });
        }, 4000);
        if (resData.data.unificationSaved == true) {
          this.setState({
            name: "",
            phone1: "",
            email1: "",
            budget: "",
            interests: "",
            location: "",
            budget: "",
            checkedInterests: [],
            // requirements: [],
            successMsg:
              "Thank You! Your nearest store representative will reach out to you shortly.",
          });
        } else {
          this.setState({
            errorMsg: "Unable to save your data. Sorry for inconvenience.",
          });
        }
      })
      .catch(e => {
        this.setState({
          // errorMsg: "Error:Unable to save your data. Sorry for inconvenience."
          errorMsg: e,
        });
      });

    // console.log(JSON.stringify(data, null, 2));
  };

  componentDidMount() {
    this.getEspotData();
  }

  render() {
    const {
      name,
      email1,
      phone1,
      //   city,
      //   pincode,
      location,
      locationErrMsg,
      budget,
      budgetErrMsg,
      nameErrMsg,
      emailErrMsg,
      phoneErrMsg,
      contactWA,
      successMsg,
      errorMsg,
      checkInterestErrMsg,
      pincode,
      pincodeErrMsg,
      possessionErrMsg,
    } = this.state;
    // console.log(contactWA + this.state.contactWA);
    return (
      <div
        id="HIConsultForm"
        className="form-bg"
        style={{
          backgroundImage: `url(${imagePrefix + this.state.bkgImg})`,
        }}
      >
        <div className="form-body-box">
          <div className="form-head">
            <h2 className="form-head-title">BOOK A CONSULTATION</h2>
            <div className="sub-title1">
              Take the first step towards making your dream home a reality by
              meeting our in-house design expert to discuss your design. Simply
              fill in the form below to book your appointment
            </div>
          </div>
          <hr />
          <div>
            <form className="form-box" method="POST">
              <div className="form-box1">
                <Col xs={12}>
                  <FormGroup>
                    <Label>
                      Location * <p className="error-msg">{locationErrMsg}</p>
                    </Label>

                    <select
                      name="dropDownValueLocation"
                      onChange={this.onDropdownSelectedLocation}
                      onClick={this.onDropdownSelectedLocation.bind(this)}
                      className="form-control"
                      required
                    >
                      <option
                        value="Select an option"
                        selected={!this.state.location}
                      >
                        Select Studio Location
                      </option>
                      {this.createSelectItems(
                        this.state.location,
                        this.state.locationList
                      )}
                    </select>
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup>
                    <Label>
                      Pincode * <p className="error-msg">{pincodeErrMsg}</p>
                    </Label>

                    <FormControl
                      type="text"
                      name="pincode"
                      className="form-control"
                      placeholder="Enter Pincode"
                      value={pincode}
                      required
                      onChange={this.fieldChangeHandler}
                      onKeyPress={this.fieldChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup>
                    <Label>
                      Name * <p className="error-msg">{nameErrMsg}</p>
                    </Label>

                    <FormControl
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Enter Full Name"
                      value={name}
                      required
                      onChange={this.fieldChangeHandler}
                      onKeyPress={this.fieldChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup>
                    <Label>
                      Mobile * <p className="error-msg">{phoneErrMsg}</p>
                    </Label>

                    <FormControl
                      type="text"
                      name="phone1"
                      className="form-control"
                      placeholder="Enter Mobile Number"
                      value={phone1}
                      required
                      onChange={this.fieldChangeHandler}
                      onKeyPress={this.fieldChangeHandler}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup className="contact-box">
                    <FormControl
                      value={contactWA}
                      onChange={this.checkedContact}
                      type="checkbox"
                      name="contactWA"
                      defaultChecked
                    />
                    <Label htmlFor="contactWA">Contact me on Whatsapp</Label>
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup>
                    <Label>
                      Email Id * <p className="error-msg">{emailErrMsg}</p>
                    </Label>{" "}
                    <FormControl
                      type="text"
                      name="email1"
                      className="form-control"
                      placeholder="Enter your email id"
                      value={email1}
                      onChange={this.fieldChangeHandler}
                      onKeyPress={this.fieldChangeHandler}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup>
                    <Label>
                      Tentative budget{" "}
                      <p className="error-msg">{budgetErrMsg}</p>{" "}
                    </Label>
                    <select
                      name="dropDownValueBudget"
                      onChange={this.onDropdownSelectedBudget}
                      onClick={this.onDropdownSelectedBudget.bind(this)}
                      className="form-control"
                    >
                      <option
                        value="Select an option"
                        selected={!this.state.budget}
                      >
                        Select Budget
                      </option>
                      {this.createSelectItems(
                        this.state.budget,
                        this.state.budgetList
                      )}
                    </select>
                    <p className="error-msg">{budgetErrMsg}</p>
                  </FormGroup>
                </Col>
              </div>
              <div className="form-box2">
                <div className="form-box2-title">
                  Please tell us about your interests
                </div>
                <p className="error-msg">{checkInterestErrMsg}</p>
                <hr className="form-box2-line" />
                <div className="form-box2-checks">
                  {this.state.interestsList.map((interest, key) => (
                    <>
                      <Col xs={12} className="form2-contact-box">
                        <FormGroup>
                          <FormControl
                            type="checkbox"
                            name={`interest${  key}`}
                            onChange={() => {
                              this.checkInterest(interest);
                            }}
                            //   onKeyPress={this.onKeyPress}
                          />
                          <Label htmlFor={`interest${  key}`}>{interest}</Label>
                        </FormGroup>
                      </Col>
                    </>
                  ))}
                </div>
                <Col className="possession" xs={12}>
                  <FormGroup>
                    <Label>
                      Please share the status of possession *
                      <p className="error-msg error-msg-mobile">{possessionErrMsg}</p>{" "}
                    </Label>
                    <select
                      name="dropDownValueBudget"
                      onChange={this.onDropdownSelectedPossession}
                      onClick={this.onDropdownSelectedPossession.bind(this)}
                      className="form-control"
                    >
                      <option
                        value="Select an option"
                        selected={!this.state.possession}
                      >
                        Select Possession
                      </option>
                      {this.createSelectItems(
                        this.state.possession,
                        this.state.possessionList
                      )}
                    </select>
                    <p className="error-msg error-msg-desktop">{possessionErrMsg}</p>
                  </FormGroup>
                </Col>
                <hr />
                <div className="form-footer">
                  <button
                    disabled={this.state.submit}
                    className="button-submit"
                    onClick={this.submitForm}
                     id = 'bac-hi'
                  >
                    SUBMIT
                  </button>
                  <span>
                    By submitting this form you agree to the{" "}
                    <a
                      target="_blank"
                      href={
                        `${imagePrefix 
                        }/B2C/homeinteriors/footer/pdf/Privacy_Policy.pdf`
                      }
                    >
                      privacy policy
                    </a>
                  </span>
                  <p className="error-msg">{errorMsg}</p>
                  {/* <p className="success-msg">{successMsg}</p> */}
                  {successMsg
                    ? (window.location.pathname = "/thank-you-homeinteriors")
                    : null}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Form;
